/*  guidance ------------------------------- */
import guidance0 from '@/json/guidance/standard.json'
import guidance1 from '@/json/guidance/multiple_da.json'
import guidance2 from '@/json/guidance/rt_stacked.json'
import guidance3 from '@/json/guidance/da_proxy.json'
import guidance4 from '@/json/guidance/da_proxy_1400.json'
import guidance5 from '@/json/guidance/da_proxy_1700.json'
import guidance6 from '@/json/guidance/no_events.json'
import guidance7 from '@/json/guidance/ncp_ceiling.json'
import guidance8 from '@/json/guidance/gen_less_demand.json'
import guidance9 from '@/json/guidance/gen_more_demand.json'
import guidance10 from '@/json/guidance/new_demand_charge_format.json'

const guidanceContainer = [
  guidance0,
  guidance1,
  guidance2,
  guidance3,
  guidance4,
  guidance5,
  guidance6,
  guidance7,
  guidance8,
  guidance9,
  guidance10
]

/*  performance ---------------------------- */
import performance_summary from '@/json/performance/summary.json'
import performance0 from '@/json/performance/single_run_5cp.json'
import performance1 from '@/json/performance/single_run_5cp.json'
import performance3 from '@/json/performance/test.json'
import performance4 from '@/json/performance/new_demand_charge_format.json'
const performanceContainer = [performance0, performance1, performance3, performance4]

/*  config --------------------------------- */
import facility_config from '@/json/facility_config.json'
import site_config from '@/json/site_config.json'

/*  simulation ------------------------------ */
import simengine from '@/json/simulate_engine.json'
import simulate0 from '@/json/simulation_300.json'
import simulate1 from '@/json/simulation_800.json'
import healthcare2MW from '@/json/healthcare_cogen2MW_solar1.6MW.json'
import healthcare3MW from '@/json/healthcare_cogen3MW_solar0.8MW.json'

import moment from 'moment'
export default {
  /* Guidance
   *    id: data file index
   *    updateDate: if true, substitute file date for current
   */
  getGuidanceData(id, updateDate = false) {
    let rawData = guidanceContainer[parseInt(id)]
    if (updateDate) {
      /* header */
      let today = moment()
      rawData.reportDate = today.format('YYYY-MM-DD')
      rawData.calculatedAt = today.subtract(23, 'minutes').toISOString()
      /* intervals */
      let ending = moment(today)
        .subtract(24, 'hours')
        .hour(19)
        .minute(45)
        .second(0)
      for (var i = 0; i < rawData.intervals.length; i++) {
        rawData.intervals[i].ending = ending.add(15, 'minutes').toISOString()
      }
    }
    return rawData
  },

  /* performance */
  getPerformanceSummary() {
    return performance_summary
  },
  getPerformanceData(id, updateDate = false) {
    
    let rawData = performanceContainer[parseInt(id)]
    if (updateDate) {
      /* header */
      let today = moment()
      rawData.report_date = today.format('YYYY-MM-DD')
      rawData.calculated_at = today.subtract(23, 'minutes').toISOString()
      /* intervals */
      let ending = moment(today)
        .subtract(24, 'hours')
        .hour(19)
        .minute(45)
        .second(0)
      for (var i = 0; i < rawData.intervals.length; i++) {
        rawData.intervals[i].ending_local = ending
          .add(15, 'minutes')
          .toISOString()
        rawData.intervals[i].ending_utc = ending
          .add(15, 'minutes')
          .toISOString()
      }
    }
    return rawData
  },

  /* simulation */
  getSimulationData(idx) {
    const simulationContainer = [
      simulate0,
      simulate1,
      healthcare2MW,
      healthcare3MW,
      simengine
    ]
    return simulationContainer[idx]
  },

  /* facility config */
  getFacilityConfiguration() {
    return facility_config
  },

  /* site config */
  getSiteConfiguration() {
    return site_config
  }
}
